"use client";

import { PublicErrorView } from "@/components/public-error-view";

type ErrorBoundaryProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalRouteError({ error, reset }: ErrorBoundaryProps) {
  return <PublicErrorView error={error} reset={reset} />;
}
